var map = {
	"./3d-glasses-1.png": 305,
	"./3d-glasses-2.png": 481,
	"./3d-glasses-3.png": 482,
	"./3d-glasses-4.png": 483,
	"./action-cam-1.png": 306,
	"./action-cam-2.png": 484,
	"./action-cam-3.png": 485,
	"./action-cam-4.png": 486,
	"./ecommerce-product-img-1.png": 307,
	"./ecommerce-product-img-2.png": 308,
	"./portable-speaker-1.png": 487,
	"./portable-speaker-2.png": 488,
	"./portable-speaker-3.png": 489,
	"./speaker-1.png": 490,
	"./speaker-2.png": 491,
	"./speaker-3.png": 492,
	"./watch-1.png": 301,
	"./watch-2.png": 493,
	"./watch-3.png": 494,
	"./watch-4.png": 495,
	"./watch-card.png": 309,
	"./white-cam-1.png": 302,
	"./white-cam-2.png": 496,
	"./white-cam-3.png": 497,
	"./white-cam-4.png": 498,
	"./white-cam-card.png": 304,
	"./wifi-1.png": 499,
	"./wifi-2.png": 500,
	"./wifi-3.png": 501,
	"./wireless-bluetooth-1.png": 303,
	"./wireless-bluetooth-2.png": 502,
	"./wireless-bluetooth-3.png": 503,
	"./wireless-bluetooth-4.png": 504,
	"./x-box-image-detail-1.png": 505,
	"./x-box-image-detail-2.png": 506,
	"./x-box-image-detail-3.png": 507,
	"./x-box-image-detail-4.png": 508,
	"./xbox-1.png": 297,
	"./xbox-2.png": 509,
	"./xbox-3.png": 510,
	"./xbox-4.png": 511,
	"./xbox-black.png": 512,
	"./xbox-blue.png": 513,
	"./xbox-red.png": 514,
	"./xbox-white.png": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;